var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FFF7ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 22V20.6667C22.6663 19.4241 21.8165 18.38 20.6663 18.084M18.333 10.1938C19.3103 10.5894 19.9997 11.5475 19.9997 12.6667C19.9997 13.7858 19.3103 14.7439 18.333 15.1395M19.333 22C19.333 20.7575 19.333 20.1362 19.13 19.6462C18.8594 18.9928 18.3402 18.4736 17.6868 18.203C17.1968 18 16.5755 18 15.333 18H13.333C12.0905 18 11.4692 18 10.9792 18.203C10.3258 18.4736 9.80665 18.9928 9.536 19.6462C9.33301 20.1362 9.33301 20.7575 9.33301 22M16.9997 12.6667C16.9997 14.1394 15.8058 15.3333 14.333 15.3333C12.8602 15.3333 11.6663 14.1394 11.6663 12.6667C11.6663 11.1939 12.8602 10 14.333 10C15.8058 10 16.9997 11.1939 16.9997 12.6667Z",
    stroke: "#F98B00",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.f7e30e1ea279d19a92e86aad9f4ce9d7.svg";
export { ForwardRef as ReactComponent };